export const CHK_BUTTON_VARIANT = {
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
  TERTIARY: 'tertiary',
  TEXT: 'text',
  LINK: 'link',
  INLINE_LINK: 'inline-link',
  INLINE_TEXT: 'inline-text',
} as const;
